import request from "@/utils/request";
import { stringify } from "qs";

// // 登录
// export function login() {
//   return request({
//     url: "/api/user/addcode",
//     method: "get",
//   });
// }

// // 轮询获取token
// export function fetchToken(params) {
//   return request({
//     url: `/api/user/decode?${stringify(params)}`,
//     method: "get",
//   });
// }

// 修改用户名和头像
export function modifyInfo(params) {
  return request({
    url: `/api/user/profile?${stringify(params)}`,
    method: "post",
  });
}

// 开始上课页面
// 获取课堂列表
export function fetchClassList(params) {
  return request({
    url: `/api/classroom/mylist?${stringify(params)}`,
    method: "get",
  });
}

// 新建课堂
export function addClass(params) {
  return request({
    url: `/api/classroom/add?${stringify(params)}`,
    method: "post",
  });
}

// 删除课堂
export function deleteClass(params) {
  return request({
    url: `/api/classroom/del?${stringify(params)}`,
    method: "post",
  });
}

// 搜索课堂
export function searchClass(params) {
  return request({
    url: `/api/classroom/search?${stringify(params)}`,
    method: "get",
  });
}

// 申请加入课堂
export function applyClass(params) {
  return request({
    url: `/api/classroom_apply/add?${stringify(params)}`,
    method: "post",
  });
}

// 再次申请加入课堂
export function applyClassAgain(params) {
  return request({
    url: `/api/classroom_apply/again?${stringify(params)}`,
    method: "post",
  });
}

// 已经加入的课堂列表
export function fetchApplyClassList(params) {
  return request({
    url: `/api/classroom_apply/list?${stringify(params)}`,
    method: "get",
  });
}

// 申请通知页面
// 我的申请
export function fetchApplyClassMyList(params) {
  return request({
    url: `/api/classroom_apply/mylist?${stringify(params)}`,
    method: "get",
  });
}
// 他人的申请
export function fetchApplyClassHeList(params) {
  return request({
    url: `/api/classroom_apply/helist?${stringify(params)}`,
    method: "get",
  });
}
// 同意或拒绝他人申请
export function fetchApplyClassSave(params) {
  return request({
    url: `/api/classroom_apply/save?${stringify(params)}`,
    method: "get",
  });
}
// 删除申请
export function fetchApplyClassDelete(params) {
  return request({
    url: `/api/classroom_apply/del?${stringify(params)}`,
    method: "get",
  });
}

// 查询房间是否需要密码
export function queryRoomPassWord(params) {
  return request({
    url: `/api/user/queryroompassword?${stringify(params)}`,
    method: "get",
  });
}

// 验证房间密码并记录历史
export function confirmRoomPassWord(params) {
  return request({
    url: `/api/user/confirmroompassword?${stringify(params)}`,
    method: "get",
  });
}

// 会议历史记录
export function fetchMeetingHistory(params) {
  return request({
    url: `/api/user/meetinghistory?${stringify(params)}`,
    method: "get",
  });
}

// 修改账号密码
export function modifyAccount(params) {
  return request({
    url: `/api/user/profile?${stringify(params)}`,
    method: "get",
  });
}

// 帐号密码登录
export function accountLogin(params) {
  return request({
    url: `/api/user/login?${stringify(params)}`,
    method: "get",
  });
}

// 获取验证码
export function sendVerifyCode(params) {
  return request({
    url: `/api/sms/send?${stringify(params)}`,
    method: "get",
  });
}

// 验证码登录
export function mobileLogin(params) {
  return request({
    url: `/api/user/mobilelogin?${stringify(params)}`,
    method: "get",
  });
}

